import {FC} from 'react'

import cn from 'classnames/bind'

import LandingsAccordion from 'components/blocks/LandingsAccordion/LandingsAccordion'
import {Col, Container, Row} from 'components/elements/grid'
import {IInvoiceContent} from 'pages/invoice-generator'

import s from './InvoiceTypes.module.scss'
import LandingsTitle from '../../LandingsTitle/LandingsTitle'
const cx = cn.bind(s)

interface IInvoiceTypesProps {
	className?: string
	content: IInvoiceContent['types']
}

/** InvoiceTypes block component */
const InvoiceTypes: FC<IInvoiceTypesProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} subtitle={content?.subtitle} />
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<table className={cx('table', 'd-none', 'd-md-table')}>
							<thead>
								<tr>
									<th className={cx('table__head', 'table__head--type', 'fs-xs')}>Invoice Type</th>
									<th className={cx('table__head', 'table__head--definition', 'fs-xs')}>
										Definition
									</th>
								</tr>
							</thead>
							<tbody>
								{content?.items?.map((item) => (
									<tr key={item._key || item.title?.linkName}>
										<td className={cx('table__cell', 'type-title')}>
											<a href={item.title?.url} target="_blank" rel="noreferrer">
												{item.title?.linkName}
											</a>
										</td>
										<td className={cx('table__cell', 'type-description', 'fs-s')}>
											{item.description}
										</td>
									</tr>
								))}
							</tbody>
						</table>
						<div className="d-md-none">
							<LandingsAccordion
								items={content?.items?.map(({title, description}) => ({
									title: title?.linkName,
									description,
								}))}
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

InvoiceTypes.displayName = 'InvoiceTypes'

export default InvoiceTypes
